import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { reviewApi } from '../../utils/reviewApi';
import '../../styles/DocReview.css';

/**
 * `/review/open?key=DMS-12677` — the landing page of the "Start Review" button the browser
 * extension draws on the Orcanos DMS form. The form only shows the item's KEY, so the server
 * finds the panel row that holds it. If the document has a review we open it — the open one,
 * else the latest, at its last round; otherwise Show reviews with Start review open (`start=1`).
 */
export default function ReviewOpenPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const key = (params.get('key') || '').trim();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!key) { setError('No DMS item was given.'); return; }
    let live = true;
    reviewApi.findItem(key).then((d) => {
      if (!live) return;
      // A review exists ⇒ open it (the open one, else the latest — at its last round);
      // none ⇒ Show reviews with Start review open (it explains when it can't start).
      const reviewId = d.review_id || d.open_review_id;
      navigate(reviewId
        ? `/review/r/${encodeURIComponent(reviewId)}`
        : `/review/item/${encodeURIComponent(d.item_id)}?setup=${d.setup_id}&start=1`,
      { replace: true });
    }).catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [key, navigate]);

  return (
    <div className="drv-page drv-page--narrow">
      <div className="drv-small"><Link className="drv-link" to="/review">← Doc Review</Link></div>
      {error
        ? <div className="drv-error" role="alert">{error}</div>
        : <div className="drv-muted">Finding {key}…</div>}
    </div>
  );
}
